import { Controller } from "@hotwired/stimulus"

// フォーム送信直後にテキストエリアをクリアする
export default class extends Controller {
    clear() {
        const textarea = this.element.querySelector("textarea")
        if (textarea) {
            textarea.value = ""
            textarea.style.height = "auto"
        }
    }
}
